import { LocaleData, LocaleConfig } from '../types';

export const config: LocaleConfig = {
    id: 'ku',
    fullName: 'Kurdish',
    nativeName: 'Kurdî (kurmancî)',
    direction: 'ltr'
};

const translations: LocaleData = {
    title: "ArgVoid",
    landing_title: "Tiştek Amazing Tê",
    landing_subtitle: "ArgVoid stûdyoyek pêşkeftina sepan û lîstikê ye. Li bendê bin, tiştên nû di nêzîk de têne!",
    select_language: "Ziman hilbijêrin",
    search_placeholder: "Li zimanan bigerin...",
    terms_title: "Mercên Xizmetê",
    policy_title: "Privacy Policy",
    cookies_title: "Siyaseta Cookie",
    terms_content: `
        <strong>1. Qebûlkirina Mercên</strong><br>
        Bi gihîştina ArgVoid, van Mercên Karûbar têne pejirandin. Ger van şertan qebûl nekin, divê xizmetê neyê bikaranîn.<br><br>

        <strong>2. Bikaranîna Platformê</strong><br>
        ArgVoid û serîlêdanên wê ji bo mebestên agahdarî û afirîner "wek ku ye" têne peyda kirin. Divê xizmet tenê ji bo mebestên qanûnî bê bikaranîn.<br><br>

        <strong>3. Reftara Qedexe </strong><br>
        Bikaranîna lawaziyên malperê, spamming, an hewildana gihîştina bêdestûr a binesaziyê bi tundî qedexe ye.<br><br>

        <strong>4. Daxuyaniya </strong><br>
        Dibe ku platform û karûbar di her kêliyê de bêyî agahdarî were guheztin. Di derbarê dema karûbarê an hebûna karûbarê de garantiyek nayê peyda kirin.
    `,
    policy_content: `
        <strong>1. Berhevoka Agahiyê</strong><br>
        Platform di vê demê de ne hewceyî pejirandina bikarhêner an çêkirina hesabê ye. Tu agahdariya nasnameya kesane (wek nav an navnîşanên e-nameyê) bi awayekî çalak ji mêvanan nayê berhev kirin.<br><br>

        <strong>2. Daneyên </strong><br> bikar bînin
        Dibe ku analîzên bingehîn, anonîmkirî werin berhev kirin da ku seyrûsefera malperê fam bikin û serîlêdanan baştir bikin. Ev dane bi nasnameyên ferdî yên bikarhêneran ve ne girêdayî ye.<br><br>

        <strong>3. Xizmetên Third-Party</strong><br>
        Dibe ku pêşkêşkerên partiya sêyemîn ji bo karûbarên mêvandar û analîtîk werin bikar anîn. Pratîkên nepenîtiyê yên van pêşkêşkerên têkildar daneyên nenas ên ku li ser binesaziya wan têne hilberandin rêve dibin.<br><br>

        <strong>4. Ewlekariya Daneyên </strong><br>
        Ji bo parastina platformê tedbîrên ewlehiyê yên maqûl têne bicîh kirin. Lêbelê, tu rêbazek veguhestinê li ser Înternetê bi tevahî ewledar nîne.<br><br>
    `,
    cookies_content: `
        <strong>1. Cookies û Depoya Herêmî çi ne?</strong><br>
        Cookies û hilanîna herêmî ya gerokê pelên daneya piçûk in ku li ser cîhazê têne hilanîn da ku di serdanê de tercihên veavakirinê bi bîr bînin.<br><br>

        <strong>2. Armanca Bikaranînê</strong><br>
        Geroka LocalStorage bi hişkî tê bikar anîn da ku mîhengên vesazkirinê hilîne, wek: <br>
        - Vebijêrkên ziman<br>
        - Veavakirina navbeynkariya bikarhêner (mînak, mîhengên layout an mijarê) <br>
        - Serîlêdana demkî cache<br><br>

        <strong>3. No Tracking</strong><br>
        Cookies û hilanîna herêmî ji bo reklam an armancên şopandina partiya sêyemîn nayên bikar anîn. Hemî daneyên hilanîn bi hişkî ji bo fonksiyona bingehîn a platformê ne.<br><br>

        <strong>4. Control</strong><br>
        Daneyên gerokê dikare di her kêliyê de bi navgîniya mîhengên gerokê ve were paqij kirin, ku dê her mîhengên herêmî ji nû ve bike.
    `,
    cookie_consent_text: "Em çerezên bingehîn bikar tînin da ku pê ewle bibin ku malper bi rêkûpêk kar dike, wek mînak rûniştina we çalak bimîne, tercîha zimanê we hilîne, û veavakirinên din ên xwerû.",
    read_policy: "Siyaseta Cookie bixwînin",
    support_title: "Têkilî Piştgiriyê",
    support_subject_label: "Mijar",
    support_message_label: "Agah",
    support_submit_button: "Peyam bişîne",
    support_hint: "Nîşe: Ev ê serîlêdana e-nameya weya xwerû ji bo şandina peyamê veke.",
    support_success_msg: "Vekirina sepana e-nameya xwe...",
    support_error_msg: "şandina peyamê bi ser neket. Ji kerema xwe paşê dîsa biceribîne.",
    explorer_title: "Lêkolînvan",
    history_title: "Dîrok",
    animation_title: "Jayandarî",
    config_title: "Veavakirin",
    tool_mouse: "Hilbijêre (Ctrl+M)",
    tool_brush: "Brush (Ctrl+B)",
    tool_brush_mode: "Moda Veguheztinê (Sor / Zelal)",
    tool_eraser: "Eraser (Ctrl+E)",
    tool_brush_size: "Mezinahiya firçeyê eyar bikin",
    tool_bucket: "Dagirtin (Ctrl+F)",
    tool_eyedropper: "Eyedropper",
    tool_grid: "Tûr (Ctrl+Shift+B)",
    tool_rotate: "Zivirandin (Ctrl+Shift+R)",
    tool_flip_h: "H-hilavêtin (Ctrl+Shift+H)",
    tool_flip_v: "Flip V (Ctrl+Shift+V)",
    tool_transpose: "Veguheztin (Ctrl+Shift+T)",
    label_width: "Berî",
    label_height: "Bilindî",
    label_frames: "Hejmara Frames",
    label_animation: "Animation Style",
    label_background_color: "Rengê Paşerojê",
    label_interval: "Navber",
    tool_anim_config: "Veavakirina Animation",
    label_new_width: "Firehiya Nû",
    label_new_height: "Bilindahiya Nû",
    label_apply: "Bikaranîn",
    label_colors: "Colors",
    label_size: "Mezinayî",
    label_tolerance: "Bêhne",
    val_horizontal: "Asumane",
    val_vertical: "Çikanî",
    val_sequence: "Dor",
    val_bounce: "Hilpekîn",
    val_random: "Bêpayîn",
    val_solid: "Liserxwe",
    val_clear: "Zelal",
    action_add_sheet: "Pelê Nû",
    action_import: "Anîn",
    action_export: "Eksport",
    action_sort_projects: "Jiberhevxistin",
    sort_date_old: "Kevintirîn Pêşî",
    sort_date_new: "Nûtirîn Pêşî",
    sort_name_az: "Nav (A-Z)",
    sort_name_za: "Nav (Z-A)",
    action_new_sprite: "New Sprite",
    action_new_project: "Projeya Nû",
    modal_save_all_title: "Hemî Guhertinan Save",
    modal_save_all_desc: "Taybetmendiyên ji bo hilanînê hilbijêrin:",
    modal_save_selected: "Hilbijartî hilînin",
    action_saved: "Saved",
    modal_create_sprite_title: "Sprite Nû biafirînin",
    modal_create_project_title: "Projeya Nû Biafirînin",
    modal_add_sheet_title: "Pelê Nû lê zêde bike",
    modal_rename_sheet_title: "Biguherîne Sheet",
    modal_rename_sprite_title: "Navê Sprite biguherîne",
    modal_delete_sprite_title: "Sprite jêbirin",
    modal_delete_project_title: "Projeyê jêbirin",
    modal_delete_sheet_title: "Pelê jêbirin",
    placeholder_sprite_name: "Nav",
    placeholder_project_name: "Nav",
    placeholder_sheet_name: "Nav",
    placeholder_new_name: "Navê Nû",
    action_create: "Xûliqandin",
    action_add: "Lêzêdekirin",
    action_rename: "Rename",
    action_duplicate: "Cote",
    action_delete: "Jêbirin",
    action_cancel: "Bişûndekirin",
    confirm_delete_sprite: "Ma tu bi rastî dixwazî ​​vê sprite jêbibî?",
    confirm_delete_project: "Ma tu bi rastî dixwazî ​​vê projeyê jê bibî? Hemî spritî dê bêne rakirin.",
    confirm_delete_sheet: "Ma tu bi rastî dixwazî ​​vê pelê jê bibî?",
    err_select_sprite: "Ji kerema xwe pêşî sprite hilbijêre.",
    err_select_project: "Ji kerema xwe pêşî projeyek hilbijêrin.",
    err_name_empty: "Nav nikare vala be.",
    err_sprite_exists: "Spîteyek bi wî navî jixwe heye.",
    err_project_exists: "Jixwe projeyek bi wî navî heye.",
    err_no_content: "Naverok tune ku xilas bike.",
    err_no_changes: "Guhertinên tomarkirinê tune.",
    err_delete_last_sheet: "Nikare pela dawî jê bibe.",
    err_extract_frames: "Nekarî ti çarçove derxe.",
    err_indexeddb: "Hilbijartina herêmî bi ser neket. Dibe ku geroka we piştgirî nede IndexedDB.",
    msg_upload_success: "Barkirin Serkeftî: {0}",
    msg_upload_failed: "Barkirin Serneket: {0}",
    msg_save_success: "Save serkeftî.",
    msg_saving: "Sazkirin...",
    msg_multi_save_result: "{0} malzemeyên hilanîn. {1} têkçûn.",
    menu_title: "Qerta xûrekê",
    menu_save: "Rizgarkirin",
    menu_save_all: "Save All",
    menu_support: "Têkilî Piştgiriyê",
    label_local_storage: "Storage Herêmî",
    label_sign_in: "Têketin",
    modal_export_title: "Export Sprite",
    label_filename: "Navê pelê",
    label_format: "Çap",
    action_export_confirm: "Eksport",
};

export default translations;
